var _line, _path, _path2, _line2, _line3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionarePrinApasare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 83,
    viewBox: "0 0 77 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.75,
    y1: 48,
    x2: 1.75,
    y2: 25,
    stroke: "black",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 47.25H17",
    stroke: "black",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 24H17",
    stroke: "black",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 35.25,
    x2: 28,
    y2: 35.25,
    stroke: "black",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 35.25,
    x2: 15,
    y2: 35.25,
    stroke: "black",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35H41",
    stroke: "black",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionarePrinApasare);
export default __webpack_public_path__ + "static/media/actionare_prin_apasare.bf7e271a8b44e3389a6d5f25107a345c.svg";
export { ForwardRef as ReactComponent };